import {
  SET_TODOS,
  SET_CURRENT_TODO_PARTICIPANT,
  IS_SUCCESS_SAVE_TODO_PARTICIPANT,
  IS_SUCCESS_DELETE_TODO_PARTICIPANT,
  IS_ERROR_DELETE_TODO_PARTICIPANT,
  IS_ERROR_SAVE_TODO_PARTICIPANT,
  RESET_CURRENT_CONTENT,
  SET_TODOS_STATUS,
  RESET_TODOS,
  SET_LATEST_FOCUS_AREA,
  SET_CURRENT_TODO_UPDATE,
} from "./actionTypes";
import {
  setFetching,
  setError,
  setSuccess,
} from "../../shared/request/actions/requestActions";
import {
  saveParticipantTodo,
  getTodosService,
  getParticipantTodo,
  updateParticipantTodo,
  deleteParticipantTodoService,
  getTodosServiceStatus,
  updateStatusTodo,
  retakeAssessment,
  getLatestFocusAreas,
} from "../service";
import { getErrorMessageFromRequestError } from "../../shared/helpers/messages/request";

export const SETTODOS = (data) => ({
  type: SET_TODOS,
  payload: data,
});

export const SET_LIST_TODOS_STATUS = (data) => ({
  type: SET_TODOS_STATUS,
  payload: data,
});

export const setCurrentTodoParticipant = (data) => ({
  type: SET_CURRENT_TODO_PARTICIPANT,
  payload: data,
});

export const setCurrentTodoUpdate = (data) => ({
  type: SET_CURRENT_TODO_UPDATE,
  payload: data,
});

export const setSuccessSaveParticipantTodo = (data) => ({
  type: IS_SUCCESS_SAVE_TODO_PARTICIPANT,
  payload: data,
});

export const setSuccessDeleteParticipantTodo = (data) => ({
  type: IS_SUCCESS_DELETE_TODO_PARTICIPANT,
  payload: data,
});
export const setErrorDeleteParticipantTodo = (data) => ({
  type: IS_ERROR_DELETE_TODO_PARTICIPANT,
  payload: data,
});
export const setErrorSaveParticipantTodo = (data) => ({
  type: IS_ERROR_SAVE_TODO_PARTICIPANT,
  payload: data,
});

export const resetCurrentContent = () => ({
  type: RESET_CURRENT_CONTENT,
});

export const clearTodos = () => ({
  type: RESET_TODOS,
});

export const setLatestFocusAreas = (data) => ({
  type: SET_LATEST_FOCUS_AREA,
  payload: data,
});

export const asyncGetTodos =
  (focusAreaId = null) =>
  async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));
    try {
      const response = await getTodosService(focusAreaId);
      dispatch(SETTODOS(response.data.data.data));
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);

      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncGetParticipantTodo = (todoId) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await getParticipantTodo(todoId);
    if (response.status === 200) {
      dispatch(setCurrentTodoParticipant(response.data.data));
    }
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncSaveParticipantTodo = (data) => async (dispatch) => {
  const successMessage = `The Task was successfully created`;
  dispatch(setFetching({ isFetching: true }));
  dispatch(
    setErrorSaveParticipantTodo({
      status: false,
      message: "",
    })
  );
  try {
    const response = await saveParticipantTodo(data);
    if (response.status === 200) {
      dispatch(
        setError({
          isOpen: true,
          message: successMessage,
          type: "success",
        })
      );
      dispatch(
        setSuccessSaveParticipantTodo({
          status: true,
          message: successMessage,
        })
      );
    }
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(setError({ isOpen: true, message, type: "error" }));
    dispatch(
      setErrorSaveParticipantTodo({
        status: true,
        message,
      })
    );
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncUpdateParticipantTodo = (data) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  dispatch(
    setErrorSaveParticipantTodo({
      status: false,
      message: "",
    })
  );
  try {
    const response = await updateParticipantTodo(data);
    if (response.status === 200) {
      dispatch(
        setSuccessSaveParticipantTodo({
          isOpen: true,
          message: "The Task was successfully updated",
          type: "success",
        })
      );
    }
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
    dispatch(
      setErrorSaveParticipantTodo({
        status: true,
        message,
      })
    );
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncUpdateStatusParticipantTodo =
  (todoId, completed) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));
    try {
      const response = await updateStatusTodo(todoId, completed);
      if (response.status === 200) {
        dispatch(
          setError({
            isOpen: true,
            message: "The To-Do was successfully updated",
            type: "success",
          })
        );
        dispatch(
          setSuccessSaveParticipantTodo({
            status: true,
            message: "The To-Do was successfully updated",
          })
        );
        dispatch(setCurrentTodoUpdate({ completed }));
      }
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);

      dispatch(setError({ isOpen: true, message, type: "error" }));
      dispatch(
        setErrorSaveParticipantTodo({
          status: true,
          message,
        })
      );
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncDeleteParticipantTodoById = (todoId) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  dispatch(
    setErrorDeleteParticipantTodo({
      status: false,
      message: "",
    })
  );
  try {
    await deleteParticipantTodoService(todoId);
    dispatch(
      setError({
        isOpen: true,
        message: "The To-Do was deleted successfully",
        type: "success",
      })
    );
    dispatch(
      setSuccessDeleteParticipantTodo({
        status: true,
        message: "The To-Do was deleted successfully",
      })
    );
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(setError({ isOpen: true, message, type: "error" }));
    dispatch(
      setErrorDeleteParticipantTodo({
        status: true,
        message,
      })
    );
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncGetTodoStatus = (params) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await getTodosServiceStatus(params);
    if (response.data.data) {
      dispatch(SET_LIST_TODOS_STATUS(response.data.data));
    }
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(setError({ isOpen: true, message, type: "error" }));
    dispatch(setErrorDeleteParticipantTodo(true));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncRetakeAssessment = (setMessageRetake) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    await retakeAssessment();
    setMessageRetake(
      "Please check your email, a new assessment was sent to you."
    );
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setSuccess({ isOpen: true, message: "", type: "success" }));
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncGetLatestFocusArea = () => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await getLatestFocusAreas();
    if (response.status === 200) {
      dispatch(setLatestFocusAreas(response.data.data.assessmentConfigs));
    }
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};
